import { useState, useEffect } from "react";

let cachedData = null;

function replacePlaceholders(obj, vars) {
    if (typeof obj === "string") {
        const wholeMatch = obj.match(/^\{(\w[\w-]*)}$/);
        if (wholeMatch && vars[wholeMatch[1]] !== undefined) {
            return vars[wholeMatch[1]];
        }
        return obj.replace(/\{(\w[\w-]*)}/g, (match, key) => {
            return vars[key] !== undefined ? vars[key] : match;
        });
    }
    if (Array.isArray(obj)) {
        return obj.map((item) => replacePlaceholders(item, vars));
    }
    if (obj && typeof obj === "object") {
        const result = {};
        for (const [key, value] of Object.entries(obj)) {
            result[key] = replacePlaceholders(value, vars);
        }
        return result;
    }
    return obj;
}

function processData(json) {
    const vars =
        json.replace_values &&
        typeof json.replace_values === "object" &&
        !Array.isArray(json.replace_values)
            ? json.replace_values
            : {};
    return { ...replacePlaceholders(json, vars), ...vars };
}

function useSeasonDetails() {
    const [data, setData] = useState(cachedData);
    const [loading, setLoading] = useState(!cachedData);

    useEffect(() => {
        if (cachedData) return;
        fetch("/config/season_details.json")
            .then((res) => res.json())
            .then((json) => {
                cachedData = processData(json);
                setData(cachedData);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load season_details.json:", err);
                setLoading(false);
            });
    }, []);

    return { data, loading };
}

export default useSeasonDetails;
